export const CARDS = [
  {
    title: 'holiday-card-warm-joy',
    image: '/img/happy-grams/holiday-card-warm-joy-left.png',
  },
  {
    title: 'holiday-card-warm-sparkle',
    image: '/img/happy-grams/holiday-card-warm-sparkle-left.png',
  },
  {
    title: 'holiday-card-warm-warm',
    image: '/img/happy-grams/holiday-card-warm-warm-left.png',
  },
];
